import {z} from '@hono/zod-openapi';

/**
 * Language a VoiceConversation is held in. The DMS resolves it from the tenant of the called
 * line; the Voice Gateway greets, listens and transcribes in it. ISO 639-1 codes. `en` exists for
 * the Voice Debug tool only; the DMS never sends it.
 */
export const VoiceLanguageSchema = z.enum(['cs', 'pl', 'de', 'en']).openapi('VoiceLanguageSchema');

export type VoiceLanguage = z.infer<typeof VoiceLanguageSchema>;
